var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headerActions,
          "left-side-class": "col-xl-8 pb-2",
          page: _vm.headerPage,
          "right-side-class":
            "col-xl align-items-end d-flex pb-4 justify-content-end"
        }
      }),
      _c("div", { staticClass: "info-card mb-4" }, [
        _c("div", { staticClass: "info-card__header" }, [
          _vm._m(0),
          _vm._v(" " + _vm._s(_vm._f("empty")(_vm.model.type?.name)) + " ")
        ]),
        _vm.model.type?.description
          ? _c("div", { staticClass: "info-card__body" }, [
              _vm._v(
                " " + _vm._s(_vm._f("empty")(_vm.model.type?.description)) + " "
              )
            ])
          : _vm._e()
      ]),
      _c(
        "validation-observer",
        { ref: "instrumentObserver" },
        [
          _vm.isStructuredInterview
            ? _c("structured-interview", {
                attrs: { "is-read-only": _vm.isReadOnly },
                on: {
                  "update:initialModel": function($event) {
                    return _vm.setInitialModel()
                  }
                },
                model: {
                  value: _vm.model.structuredInterview,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "structuredInterview", $$v)
                  },
                  expression: "model.structuredInterview"
                }
              })
            : _vm.isDisabilityEvaluationQuestionnaire
            ? _c("disability-evaluation-questionnaire", {
                attrs: { "is-read-only": _vm.isReadOnly },
                on: {
                  "update:initialModel": function($event) {
                    return _vm.setInitialModel()
                  }
                },
                model: {
                  value: _vm.model.disabilityEvaluationQuestionnaire,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.model,
                      "disabilityEvaluationQuestionnaire",
                      $$v
                    )
                  },
                  expression: "model.disabilityEvaluationQuestionnaire"
                }
              })
            : _vm.isInterestProfile
            ? _c("interest-profile", {
                attrs: { "is-read-only": _vm.isReadOnly },
                on: {
                  "update:initialModel": function($event) {
                    return _vm.setInitialModel()
                  }
                },
                model: {
                  value: _vm.model.interestProfile,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "interestProfile", $$v)
                  },
                  expression: "model.interestProfile"
                }
              })
            : _vm.isLearningStylesRelevantToPerformance
            ? _c("learning-styles-relevant-to-performance", {
                attrs: { "is-read-only": _vm.isReadOnly },
                on: {
                  "update:initialModel": function($event) {
                    return _vm.setInitialModel()
                  }
                },
                model: {
                  value: _vm.model.learningStylesRelevantToPerformance,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.model,
                      "learningStylesRelevantToPerformance",
                      $$v
                    )
                  },
                  expression: "model.learningStylesRelevantToPerformance"
                }
              })
            : _vm.isWorkSampleExecution
            ? _c("work-sample-execution", {
                attrs: { "is-read-only": _vm.isReadOnly },
                on: {
                  "update:initialModel": function($event) {
                    return _vm.setInitialModel()
                  }
                },
                model: {
                  value: _vm.model.workSampleExecution,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "workSampleExecution", $$v)
                  },
                  expression: "model.workSampleExecution"
                }
              })
            : _vm.isValparSystem
            ? _c("valpar-system-sample", {
                attrs: { "is-read-only": _vm.isReadOnly },
                on: {
                  "update:initialModel": function($event) {
                    return _vm.setInitialModel()
                  }
                },
                model: {
                  value: _vm.model.valparSystemSample,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "valparSystemSample", $$v)
                  },
                  expression: "model.valparSystemSample"
                }
              })
            : _vm.isSAMPR
            ? _c("samr-oral-instruction-screen", {
                attrs: { "is-read-only": _vm.isReadOnly },
                on: {
                  "update:initialModel": function($event) {
                    return _vm.setInitialModel()
                  }
                },
                model: {
                  value: _vm.model.samrOralInstructionScreen,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "samrOralInstructionScreen", $$v)
                  },
                  expression: "model.samrOralInstructionScreen"
                }
              })
            : _vm.isBasicSkillsTest
            ? _c("basic-skills-test", {
                attrs: { "is-read-only": _vm.isReadOnly },
                on: {
                  "update:initialModel": function($event) {
                    return _vm.setInitialModel()
                  }
                },
                model: {
                  value: _vm.model.academicSkillsTest,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "academicSkillsTest", $$v)
                  },
                  expression: "model.academicSkillsTest"
                }
              })
            : _vm.isOtherAcademicTests
            ? _c("other-academic-tests", {
                attrs: { "is-read-only": _vm.isReadOnly },
                on: {
                  "update:initialModel": function($event) {
                    return _vm.setInitialModel()
                  }
                },
                model: {
                  value: _vm.model.otherAcademicTests,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "otherAcademicTests", $$v)
                  },
                  expression: "model.otherAcademicTests"
                }
              })
            : _vm._e()
        ],
        1
      ),
      !_vm.isReadOnly
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c("action-button", {
                attrs: {
                  i: "fas fa-save",
                  text: "Guardar",
                  variant: "success pl-3 pr-3 my-3"
                },
                on: {
                  click: function($event) {
                    return _vm.save()
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "py-1 px-2 bg-white rounded-circle mr-2 shadow-sm" },
      [_c("i", { staticClass: "fas fa-book-user text-orange" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }